import { BaseUserTierDto, UserTierDto } from '../../../config/finance/financeConfig'
import * as React from 'react'
import { ReactElement } from 'react'
import { baseListStyles } from '../../List/BaseList'
import useCurrency from '../../../hooks/useCurrency'
import useUsers from '../../../hooks/useUsers'
import { Stack, Text } from '@fluentui/react'
import MoneyText from '../../Text/Currency/MoneyText'
import { useTranslation } from 'react-i18next'

export type UserTierListItemProps<TierT extends BaseUserTierDto> = {
    index: number
    item: TierT
    editTier: (index: number) => void
}

export function UserTierListItem(props: UserTierListItemProps<UserTierDto>): ReactElement {
    const { t: translate } = useTranslation()
    const { currency } = useCurrency(props.item.currency)
    const { users } = useUsers()

    return (
        <Stack horizontal styles={{ root: baseListStyles.itemCell }} onClick={() => props.editTier(props.index)}>
            <Stack horizontal={false} style={{ flexGrow: 1, minWidth: 0 }} tokens={{ childrenGap: 's2' }}>
                <Text style={{ flexGrow: 1, minWidth: 0 }}>
                    {users.find(user => user.id === props.item.userId)?.fullName || '?'}
                </Text>
            </Stack>
            <Stack horizontal={false} horizontalAlign={'end'} tokens={{ childrenGap: 's2' }}>
                <Stack horizontal tokens={{ childrenGap: 's2' }}>
                    <Text>{translate('file.edit.form.finance.rates.tier.purchaserate')}: </Text>
                    <MoneyText amount={props.item.purchaseRate} currency={currency} />
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 's2' }}>
                    <Text>{translate('file.edit.form.finance.rates.tier.salesrate')}: </Text>
                    <MoneyText amount={props.item.salesRate} currency={currency} />
                </Stack>
            </Stack>
        </Stack>
    )
}
